import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    width: 80,
    height: 80,
    position: "relative",
  },
  svg: {
    width: "100%",
    height: "100%",
  },
  fillRed: {
    fill: "#f44336",
  },
  fillBlue: {
    fill: "#1976d2",
  },
  maskRect: {
    animation: "$fillUp 2s infinite",
    transformOrigin: "bottom",
  },
  "@keyframes fillUp": {
    "0%": {
      transform: "scaleY(0)",
    },
    "100%": {
      transform: "scaleY(1)",
    },
  },
});

const LogoLoading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <svg
        viewBox="0 0 64 64"
        className={classes.svg}
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Máscara de preenchimento */}
        <defs>
          <mask id="fillMask">
            <rect
              x="0"
              y="0"
              width="64"
              height="64"
              fill="white"
              className={classes.maskRect}
            />
          </mask>
        </defs>

        {/* Pino Vermelho */}
        <path
          d="M32 4C22.6 4 15 11.6 15 21c0 10.5 17 29 17 29s17-18.5 17-29c0-9.4-7.6-17-17-17zm0 23a6 6 0 1 1 0-12 6 6 0 0 1 0 12z"
          className={classes.fillRed}
          mask="url(#fillMask)"
        />

        {/* Base Azul estilizada */}
        <path
          d="M18 56h28l-4-4H22l-4 4zm6-8h16l-4-4H28l-4 4z"
          className={classes.fillBlue}
          mask="url(#fillMask)"
        />
      </svg>
    </Box>
  );
};

export default LogoLoading;
